<template>
    <div class="blog-header">
        <h1 class="blog-header__title">{{title}}</h1>
        <div class="blog-header__author-info">
            <div class="blog-header__author-name">{{author.name}}</div>
            <div class="blog-header__meta-box">
                <span class="blog-header__date">{{publishDate}}</span>
                <span class="blog-header__break">•</span>
                <span class="blog-header__read">{{views}} 次阅读</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from '@utils'

    export default {
        name: "BlogHeader",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            author() {
                const {data} = this
                return data.author || {}
            },
            // 发布日期
            publishDate() {
                const {data} = this
                const {publishDate} = data || {}
                if (publishDate) {
                    return formatDate(new Date(publishDate), 'yyyy年MM月dd日')
                }
                return '无'
            },
            views() {
                const {data} = this
                const {views} = data || {}
                return views || 0
            },
            title() {
                const {data} = this
                const {title} = data || {}
                return title || '无'
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .blog-header {
        margin-bottom: $paddingMD;

        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeLG;
            font-weight: $fontWeightBolder;
            margin-bottom: $paddingMD;
            @include transition-colors;

        }

        &__author-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: $fontSizeCommon;
        }

        &__author-name {
            color: $textColor;
            color: var(--textColor);
            font-weight: $fontWeightBold;
            @include transition-colors;
        }

        &__break {
            margin: 0 $paddingBase;
        }

        &__date,
        &__break,
        &__read {
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
            @include transition-colors;
        }
    }
</style>